import type { SVGProps } from "react";

export const IndexAdditionalRecordsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M17.5 4.16675C17.5 5.54746 14.1421 6.66675 10 6.66675C5.85786 6.66675 2.5 5.54746 2.5 4.16675M17.5 4.16675C17.5 2.78604 14.1421 1.66675 10 1.66675C5.85786 1.66675 2.5 2.78604 2.5 4.16675M17.5 4.16675L17.5 9.00012M2.5 4.16675L2.50006 15.8334C2.49541 16.2342 2.77989 16.6294 3.3295 16.9859C3.87911 17.3423 4.67774 17.6495 5.65809 17.8815C6.63843 18.1135 7.77174 18.2636 8.96248 18.319C10.1532 18.3745 11.3665 18.3337 12.5001 18.2001M16.5 13.0001V17.0335M2.5 10.0001C2.5012 10.3897 2.77557 10.7738 3.30121 11.1218C3.82685 11.4698 4.58921 11.772 5.52747 12.0043C6.46573 12.2367 7.5539 12.3927 8.70518 12.46C9.85645 12.5272 11.039 12.5039 12.1583 12.3917M14.5 15.0001H18.5"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
